
































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import Serachworkgroup from '@/store/entities/sm/searchworkgroup'
import CreateWorkGroup from './create-workgroup.vue'
import UpdateWorkGroup from './edit-workgorup.vue'
import CheckWorkGroup from './check-workgroup.vue'
@Component({
  components: { CreateWorkGroup, UpdateWorkGroup, CheckWorkGroup }
})
export default class MailList extends AbpBase {
  Serachworkgroup: Serachworkgroup = new Serachworkgroup()
  createworkgroupshow: boolean = false
  updateworkgroupshow: boolean = false
  checkworkgroupshow: boolean = false
  loadingInstance:boolean=false;
  wxgroupid: string = ''
  get list() {
    return this.$store.state.workgroup.list
  }
  // get categorylist() {
  //   return this.$store.state.workgroup.categorylist
  // }
  get loading() {
    return this.$store.state.workgroup.loading
  }
  async editrow(row) {
    await this.$store.dispatch('workgroup/GetWorkGroupData', { wid: row.id })
    this.updateworkgroupshow = true
  }
  //查看单条组群信息
  async getworkgroup(row) {
    await this.$store.dispatch('workgroup/GetWorkGroupData', { wid: row.id })
    this.checkworkgroupshow = true
  }
  //删除组群
  async delrow(row) {
    // this.$Modal.confirm({
    //   title: '提示',
    //   content: '确定要删除当前【'+row.groupName+'】组群吗？',
    //   okText: '确定',
    //   cancelText: '取消',
    //   onOk: async () => {
    //     let response = await this.$store.dispatch({
    //       type: 'workgroup/DeleteWorkGroup',
    //       data: { wid: row.id }
    //     })
    //     if (response.success) {
    //       this.$message({
    //         type: 'success',
    //         message: '删除成功'
    //       })
    //       this.getpage()
    //     } else {
    //       this.$message({
    //         type: 'warning',
    //         message: '删除失败'
    //       })
    //       this.getpage()
    //     }
    //   }
    // })
    this.$confirm('确定要删除当前【'+row.groupName+'】工作组群吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(async () => {
          let response = await this.$store.dispatch({
            type: 'workgroup/DeleteWorkGroup',
            data: { wid: row.id }
          })
          if (response.success) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getpage()
          } else {
            this.$message({
              type: 'warning',
              message: '删除失败'
            })
            this.getpage()
          }
      })
      .catch(() => {});

  }
  createworkgroup() {
    this.createworkgroupshow = true
  }
  pageChange(page: number) {
    this.$store.commit('workgroup/setCurrentPage', page)
    this.getpage()
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit('workgroup/setPageSize', pagesize)
    this.getpage()
  }
  async getpage() {
    this.loadingInstance=true;
    this.Serachworkgroup.maxResultCount = this.pageSize;
    this.Serachworkgroup.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: 'workgroup/GetWorkGroupList',
      data: this.Serachworkgroup
    });
    this.loadingInstance=false;
  }
  get pageSize() {
    return this.$store.state.workgroup.pageSize;
  }
  get totalCount() {
    return this.$store.state.workgroup.totalCount;
  }
  get currentPage() {
    return this.$store.state.workgroup.currentPage;
  }
  async created() {
   await this.getpage();
  }
  mounted() {}
}
